/* unplugin-vue-components disabled */import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import formatAmount from '@/shared/formatAmount';
import TrackingData from '@/shared/reportDataTracking';
import { useUserStore } from '@/stores/modules/user';
export default {
    __name: 'cost-detail-popup',
    props: {
        value: Boolean,
        repayObj: Object
    },
    emits: [
        'close'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var userStore = useUserStore();
        var enterTime = ref(new Date());
        watch(function() {
            return props.value;
        }, function(val) {
            if (val) {
                TrackingData.trackPopup(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_fee_detail',
                    taskHandler: 'popup-show'
                }));
            } else {
                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_fee_detail',
                    taskHandler: 'popup-confirm',
                    eventIntervalSpan: new Date() - enterTime.value
                }));
            }
        });
        var onOpenedPopup = function() {
            console.log('open');
        };
        var onClosedPopup = function() {
            console.log('close');
        };
        return {
            __sfc: true,
            userStore: userStore,
            props: props,
            emit: emit,
            enterTime: enterTime,
            onOpenedPopup: onOpenedPopup,
            onClosedPopup: onClosedPopup,
            formatAmount: formatAmount
        };
    }
};
